export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  tws: 1348,
  xl2: 1536,
};
export const APP_BAR_CHECK_COOKIE = "appBarClosed";
export const APP_BAR_CHECK_HEADER = "X-App-Bar-Closed";

export const START_PAGE_SLUG = "index";
export const PLAY_PAGE_SLUG = "play";

export const INFINITE_SCROLL_ARTICLE_LIMIT = 10;
export const INFINITE_SCROLL_ITEMS_PER_FETCH = 1;
export const ITEM_FEED_LIMIT = 10;

export const INFINITE_SCROLL_CATEGORY_LIMIT = 10;

// Play
export const BORSLUNCH_SHOW_ID = "xDATcGU6kUHN5jrwaNSxLY";
export const EFN_DIREKT_SHOW_ID = "rCGu0i5Hlo3MxqjMqf9Wgb";

// Podcast
export const BORSLUNCH_PODCAST_SHOW_ID = "Nv1QADTUGhE5g6EB8xBVqj";
export const EFN_DIREKT_PODCAST_SHOW_ID = "E2EaNX25hQs0tp7aHm0VZl";

// ARTICLE
export const EFN_ANALYSIS_CATEGORY_ID = "IGC2aanuWkYY9Ci5NMMwFA";
export const EFN_REPORT_COMMENTS_CATEGORY_ID = "P35FZ4xhH6fYIgBsv5qor4";
export const EFN_COMMENTS_CATEGORY_ID = "vtJ9s0FkgEnlfXMvJ8fJ7c";

export const EFN_SCIENCE_CATEGORY_ID = "Q7w5M00z7SVitrZAychcWa";

export const EFN_SCIENCE_TAG_SLUG = "Vetenskap";

export const INDEX_BREAKING_ID = "core-index-just-nu";

export const APP_USER_AGENT = "EFN-app/";

export function isAppRequest(headers: Headers): boolean {
  const userAgent = headers.get("user-agent");
  return userAgent ? userAgent.startsWith(APP_USER_AGENT) : false;
}

export function getAppVersion(headers: Headers): string | null {
  const userAgent = headers.get("user-agent")?.trim();

  if (!userAgent) {
    return null;
  }

  if (!userAgent.startsWith(APP_USER_AGENT)) {
    return null;
  }

  const version = userAgent.substring(APP_USER_AGENT.length);
  return version || null;
}

export const SITEMAP_URL_LIMIT = 1000;

export const FM_PROMO_IMAGE_ID = "YerWWrS5GCxbPClYslUgTq";

export const LIVE_REPORT_LIMIT = 50;

export const THEME_COOKIE = "theme";

export const NYHETSBYRAN_DIREKT_AUTHOR_ID = "JKIcZ6A9xplFNzZ6KvC5YI";
